export const PROJECT_NOTIFICATION_EVENT = 'project:notification'

export interface ProjectNotificationDetail {
    text: string
    type?: 'success' | 'error'
    action?: {
        label: string
        onClick: () => void
    }
}

export const dispatchProjectNotification = (detail: ProjectNotificationDetail) => {
    if (typeof window === 'undefined') return
    window.dispatchEvent(new CustomEvent(PROJECT_NOTIFICATION_EVENT, { detail }))
}
